import { defineComponent } from 'vue'
import { useDialog } from 'primevue/usedialog'
import Button from 'primevue/button'
import imgUrl from '/img/logo.png'

export async function openLikeDialog(opts: {
  dialog: ReturnType<typeof useDialog>,
  onLikeYes?: () => void,
  onLikeNo?: () => void
}): Promise<void> {
  const { dialog, onLikeYes, onLikeNo } = opts || {}

  let closed = false

  function close(type: 'yes' | 'no') {
    if (closed) return
    closed = true
    dialogRef.close()
    if (type === 'yes' && onLikeYes) onLikeYes()
    else if (type === 'no' && onLikeNo) onLikeNo()
  }

  const DialogContent = defineComponent({
    setup (_props, _context) {
      return () => (
        <div class="tw:w-full tw:p-1 tw:pt-4" style="color: var(--primary-dark-blue);">
          <div class="body tw:flex tw:flex-col tw:w-full tw:items-center tw:pb-2">
            <img src={imgUrl} class="tw:w-36" />
            <div class="tw:text-lg tw:font-extrabold tw:m-2">
              Do you like using Fareclock?
            </div>
            <div class="tw:flex tw:gap-2">
              <Button
                type="button"
                size="small"
                outlined
                severity="danger"
                label="Not really"
                icon="pi pi-thumbs-down"
                class='tw:w-32 tw:py-1 tw:rounded-xs'
                pt={ { label: '!tw:text-sm' } }
                onClick={() => {
                  close('no')
                }}
              />
              <Button
                type="button"
                size="small"
                outlined
                severity="success"
                label="Yes!"
                icon="pi pi-face-smile"
                class='tw:w-32 tw:py-1 tw:rounded-xs'
                pt={ { label: 'tw:font-extrabold !tw:text-sm' } }
                onClick={() => {
                  close('yes')
                }}
              />
            </div>
          </div>
        </div>
      )
    }
  })

  const dialogRef = dialog.open(DialogContent, {
    props: {
      style: {
        width: '350px'
      },
      pt: {
        root: 'tw:rounded-xs',
        header: 'tw:flex-row-reverse tw:px-2 tw:pt-1 tw:pb-0',
        pcCloseButton: { root: 'tw:w-4 tw:h-4', icon: { class: 'tw:w-3 tw:h-3' } },
        content: 'tw:p-0'
      },
      modal: true,
      dismissableMask: false,
      // show over feedback modal's z-index of 1103
      baseZIndex: 1104,
      showHeader: false
    }
  })
}
